import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/7_burgundy/7_burgundy"
 * Contains 1 texture(s)
 */
export class Desktop7BurgundyAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/7_burgundy/7_burgundy';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '7_burgundy.png'
    ] as const;
}
